<form [formGroup]="fG">
  @if (!notBefore && !notAfter) {
    <ejs-datepicker [placeholder]="placeholder" [formControlName]="fCN" [showClearButton]="showClearButton" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '') + (onlyDisplayIcon?'onlydatepickericon':'')"></ejs-datepicker>
  }

  @if (notBefore && !notAfter) {
    <ejs-datepicker [min]='notBefore' [placeholder]="placeholder" [formControlName]="fCN" [showClearButton]="showClearButton" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '') + (onlyDisplayIcon?'onlydatepickericon':'')"></ejs-datepicker>
  }

  @if (!notBefore && notAfter) {
    <ejs-datepicker [max]='notAfter' [placeholder]="placeholder" [formControlName]="fCN" [showClearButton]="showClearButton" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '') + (onlyDisplayIcon?'onlydatepickericon':'')"></ejs-datepicker>
  }

  @if (notBefore && notAfter) {
    <ejs-datepicker [min]='notBefore' [max]='notAfter' [placeholder]="placeholder" [formControlName]="fCN" [showClearButton]="showClearButton" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '') + (onlyDisplayIcon?'onlydatepickericon':'')"></ejs-datepicker>
  }
</form>
